import React, { useState } from 'react';
import ModernFormLanding from './ModernFormLanding';
import SpecialWordsManager from './SpecialWordsManager';
import './App.css';

function App() {
  // Start with an empty specialWords list
  const [specialWords, setSpecialWords] = useState([]);
  return (
    <>
      <ModernFormLanding specialWords={specialWords} />
      <SpecialWordsManager specialWords={specialWords} setSpecialWords={setSpecialWords} />
    </>
  );
}

export default App;